import { XmlTvSettingsSchema } from './schemas/settingsSchemas.js';
export const defaultXmlTvSettings = XmlTvSettingsSchema.parse({});
//# sourceMappingURL=XmlTvSettings.js.map